(function () {
  'use strict';
  if (document.documentElement.lang.toLowerCase() !== 'pt-pt') return;
  var marker = document.getElementById('gw-pt-pt-entry-20261016-v1');
  if (!marker || marker.getAttribute('data-gw-pt-pt-country') !== 'PT') return;
  var root = (marker.getAttribute('data-gw-pt-pt-root') || '').replace(/\/+$/, '');
  var path = window.location.pathname.replace(/\/+$/, '');
  if (!/^\/pt(?:-pt){0,2}$/.test(root) || path !== (marker.getAttribute('data-gw-pt-pt-path') || '').replace(/\/+$/, '')) return;
  var key = marker.getAttribute('data-gw-pt-pt-entry');
  var tails = {
    recorder: '/pages/gladwares-ai-recorder', cart: '/cart', faq: '/pages/faqs',
    contact: '/pages/content', refund: '/policies/refund-policy',
    privacy: '/policies/privacy-policy', shipping: '/policies/shipping-policy',
    terms: '/policies/terms-of-service', tracking: '/apps/17TRACK',
    recorder_product: '/products/magnetic-ai-powered-voice-recorder',
    headphones: '/products/2026-noise-cancelling-wireless-headphones',
    hub: '/products/8-in-1-dual-usb-c-hub',
    folding_keyboard: '/products/folding-keyboard-with-smart-trackpad',
    air_mouse: '/products/mini-m5-dual-mode-wireless-air-mouse-keyboard'
  };
  if (!tails[key] || path.toLowerCase() !== (root + tails[key]).toLowerCase()) return;
  var images;
  try { images = JSON.parse(marker.textContent).images; } catch (error) { return; }
  var alts = {
    "lux-img-1": "Gladwares MemoryCard AI Pro: gravar, transcrever e resumir",
    "lux-img-1-1": "Gladwares MemoryCard AI Pro: gravar, transcrever e resumir",
    "lux-img-2": "Da conversa ao texto claro",
    "lux-img-3": "Registe ideias, compromissos e instruções",
    "lux-img-4": "Transcrição, pontos-chave e tarefas",
    "lux-img-5": "Faça a gestão das gravações na aplicação DOWAY",
    "lux-img-6": "Grave conversas e consulte os detalhes mais tarde",
    "lux-img-7-1": "Grave e resuma reuniões",
    "lux-img-7-2": "Os pontos-chave das suas conversas",
    "lux-img-7-3": "Notas para estudar e trabalhar",
    "lux-img-7-4": "Compromissos e tarefas organizados",
    "lux-img-8-1": "Grave, transcreva e resuma",
    "lux-img-8-2": "Encontre os pontos mais importantes",
    "lux-img-8-3": "Exemplo de resumo de reunião com pontos-chave, decisões e próximos passos.",
    "lux-img-8-4": "Encontre qualquer momento da conversa",
    "lux-img-9-1": "Um e-mail de seguimento, pronto a enviar",
    "lux-img-9-2": "Dados dos clientes sempre à mão",
    "lux-img-9-3": "Exemplo de sugestão de IA: preparar uma comparação breve para revisão.",
    "lux-img-9-4": "Exemplo de perfil de cliente atualizado com informações de duas conversas.",
    "P5-1": "Carregue no botão e registe tudo",
    "P5-2": "Transcrição e resumos sem subscrição",
    "P5-3": "152 idiomas na aplicação DOWAY",
    "P5-4": "Grave, transcreva e resuma",
    "P5-5": "64 GB com capacidade para até 450 horas",
    "P5-6": "Gravador magnético fino, do tamanho de um cartão bancário"
};
  function setImage(img, id) {
    var url = images[id];
    if (!img || img.tagName !== 'IMG' || !url) return;
    var hero = id === 'lux-img-1' || id === 'lux-img-1-1';
    var mobile = window.matchMedia('(max-width: 767.4999px)').matches;
    if (hero) {
      var visible = mobile ? id === 'lux-img-1-1' : id === 'lux-img-1';
      img.setAttribute('loading', visible ? 'eager' : 'lazy');
      img.setAttribute('fetchpriority', visible ? 'high' : 'auto');
    }
    if (img.getAttribute('src') !== url) img.setAttribute('src', url);
    img.setAttribute('data-src', url);
    img.setAttribute('data-srcset', url);
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('alt', alts[id] || '');
    var picture = img.closest('picture');
    if (picture) picture.querySelectorAll('source').forEach(function (source) {
      source.setAttribute('srcset', url);
      source.setAttribute('data-srcset', url);
    });
  }
  function imagesOnce() {
    if (key !== 'recorder') return;
    Object.keys(images).forEach(function (id) {
      if (id.indexOf('lux-img-') === 0) setImage(document.getElementById(id), id);
    });
    var thumbs = document.querySelectorAll('#lux-thumb-strip .lux-thumb');
    if (thumbs.length !== 6) return;
    thumbs.forEach(function (thumb, index) {
      var id = 'P5-' + (index + 1);
      thumb.setAttribute('data-pt-image', images[id]);
      thumb.setAttribute('data-pt-pt-image', images[id]);
      thumb.setAttribute('data-image', images[id]);
      thumb.setAttribute('aria-label', alts[id]);
      setImage(thumb.querySelector('img'), id);
    });
    var active = document.querySelector('#lux-thumb-strip .lux-thumb.is-active') || thumbs[0];
    setImage(document.getElementById('lux-main-image'), 'P5-' + (Array.prototype.indexOf.call(thumbs, active) + 1));
  }
  function localLinks(container) {
    var permitted = Object.keys(tails).map(function (name) { return tails[name].toLowerCase(); });
    container.querySelectorAll('a[href]').forEach(function (a) {
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.origin); } catch (error) { return; }
      if (url.origin === window.location.origin) {
        var relative = url.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
        if (permitted.indexOf(relative.replace(/\/+$/, '').toLowerCase()) !== -1) {
          var target = root + relative + url.search + url.hash;
          if (a.getAttribute('href') !== target) a.setAttribute('href', target);
        }
      } else if (url.hostname === 'shopify.com' && url.pathname === '/9182642261/account/orders') {
        url.searchParams.set('locale', 'pt-PT');
        url.searchParams.set('region_country', 'PT');
        a.setAttribute('href', url.href);
      }
    });
  }
  function bundleText() {
    document.querySelectorAll('#lux-bundle-area .engrave-input').forEach(function (input) {
      input.setAttribute('placeholder', 'Introduza o seu nome ou texto');
    });
  }
  function miniCartText() {
    document.querySelectorAll('.mini-cart__item').forEach(function (item) {
      if (!item.querySelector('a[href*="/products/magnetic-ai-powered-voice-recorder"]')) return;
      item.querySelectorAll('.line-item').forEach(function (line) {
        if (line.childElementCount === 0 && /^\s*Engraving(?=\s|:|\d|$)/.test(line.textContent)) {
          line.textContent = line.textContent.replace(/^(\s*)Engraving/, '$1Gravação personalizada');
        }
      });
    });
    document.querySelectorAll('.cart_content').forEach(localLinks);
  }
  function init() {
    imagesOnce();
    localLinks(document);
    bundleText();
    miniCartText();
    var bundle = key === 'recorder' ? document.getElementById('lux-bundle-area') : null;
    if (bundle && typeof MutationObserver !== 'undefined') {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          bundleText();
        });
      }).observe(bundle, {childList: true, subtree: true});
    }
    document.addEventListener('gw-pt-pt-cart-rendered', miniCartText);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();

